import { render, staticRenderFns } from "./ui-select.vue?vue&type=template&id=26c2b028&scoped=true"
import script from "./ui-select.vue?vue&type=script&lang=ts"
export * from "./ui-select.vue?vue&type=script&lang=ts"
import style0 from "./ui-select.vue?vue&type=style&index=0&id=26c2b028&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c2b028",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26c2b028')) {
      api.createRecord('26c2b028', component.options)
    } else {
      api.reload('26c2b028', component.options)
    }
    module.hot.accept("./ui-select.vue?vue&type=template&id=26c2b028&scoped=true", function () {
      api.rerender('26c2b028', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/ui/forms/select/ui-select.vue"
export default component.exports